// PlannerHeaderWeek Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class PlannerHeaderWeek extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      activeDays: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      item: null,
      activeDays: []
    }
  }

  render () {
    const { item } = this.props
    return (
      <div className={`planner-headerweek${item.isActive ? ' active' : ''}`}>
        <div className='title'>Week {item.weekNo}</div>
        <div className='days'>
          {item.items.map((dayObj, idx) => (
            <span
              key={idx}
              className={`item${dayObj.isWeekEnd ? ' disabled' : ''}`}
            >
              {dayObj.title}
            </span>
          ))}
        </div>
        <div className='values'>
          {item.items.map((dayObj, idx) => (
            <span
              key={idx}
              className={classnames('item', {
                active: dayObj.isActive,
                disabled: dayObj.isWeekEnd
              })}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default PlannerHeaderWeek
